import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Header from 'components/CameraModelSelector/Header'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'

const ListItem = ({ data, index, style }) => {
  const { manufacturers, selectedManufacturer, setManufacturer, classes } = data
  const manufacturer = manufacturers[index]
  const selected = selectedManufacturer && selectedManufacturer === manufacturer

  return (
    <div
      onClick={_ => setManufacturer(selected ? null : manufacturer)}
      className={selected ? classes.selected : (index % 2 === 0 ? classes.listItemOdd : classes.listItemEven)}
      style={style}
    >
      <span className={classes.manufacturerName}>{manufacturer}</span>
      { manufacturer === 'Recent' && <FontAwesomeIcon icon='history' className={classes.clock} /> }
      { manufacturer === 'Favorite' && <FontAwesomeIcon icon='star' className={classes.star} /> }
    </div>
  )
}

const ManufacturerList = ({ manufacturers, selectedManufacturer, setManufacturer, classes }) =>
  <div className={classes.container}>
    <Header title='Brands' />
    <div style={{ flex: '1 1 auto' }}>
      <AutoSizer disableWidth>
        {({ height }) => (
          <List
            height={height}
            itemCount={manufacturers.length + 2}
            itemData={{ manufacturers: ['Recent', 'Favorite'].concat(manufacturers), selectedManufacturer, setManufacturer, classes }}
            itemSize={27}
            width={'100%'}
            className={classes.list}
          >
            { ListItem }
          </List>
        )}
      </AutoSizer>
    </div>
  </div>

export default injectSheet(style)(ManufacturerList)



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ManufacturerList/index.js